module.exports = __webpack_public_path__ + "media/img/4 year-0100e70f.png";